'use strict';

exports.__esModule = true;
exports.default = {
  SMALL: 'small',
  LARGE: 'large'
};
//# sourceMappingURL=LikeSize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/constants/LikeSize.js
// module id = 134
// module chunks = 95715928098905 172441821870073 232727283551173